import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import cx from 'classnames';
import { displayEdition } from '../modals';

class ManipButtons extends Component {
  constructor(props, context) {
    super(props, context);

    this._intervention = context.intervention;
    this._type = context.type;

    this.state = {
      isLoading: false,
    };

    this._showEdit = this._showEdit.bind(this);
    this._showSee = this._showSee.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  _showEdit(evt) {
    evt.preventDefault();

    const { manip, onUpdated, onDeleted } = this.props;

    this.setState({
      isLoading: true,
    });

    // Display modal
    displayEdition(
      this._intervention,
      manip,
      this._type,
      onUpdated,
      onDeleted,
      false,
      manip.is_deletable
    ).then(() => {
      this.setState({
        isLoading: false,
      });
    });
  }

  _showSee(evt) {
    evt.preventDefault();

    const { manip, onUpdated, onDeleted } = this.props;

    this.setState({
      isLoading: true,
    });

    // Display modal
    displayEdition(
      this._intervention,
      manip,
      this._type,
      onUpdated,
      onDeleted,
      true,
      manip.is_deletable
    ).then(() => {
      this.setState({
        isLoading: false,
      });
    });
  }

  render() {
    const { isLoading } = this.state;
    const { manip, hideHistory, disabled } = this.props;

    const editButtonClass = cx('ui icon button', {
      loading: isLoading,
    });

    const seeButtonClass = cx('ui icon button', {
      loading: isLoading,
    });

    return (
      <td>
        <div className="ui basic buttons">
          {!disabled && (
            <button className={editButtonClass} onClick={this._showEdit}>
              <i className="edit icon" />
              Editer
            </button>
          )}
          {disabled && (
            <button className={seeButtonClass} onClick={this._showSee}>
              <i className="edit icon" />
              Voir
            </button>
          )}
          {!manip.new && !hideHistory && (
            <a
              href={`/pco-manager/zones/points/${manip.id}?intervention=${this._intervention}`}
              className="ui icon button"
            >
              <i className="history icon" />
              Historique
            </a>
          )}
        </div>
      </td>
    );
  }
}

ManipButtons.propTypes = {
  manip: PropTypes.object.isRequired,
  onUpdated: PropTypes.func.isRequired,
  onDeleted: PropTypes.func.isRequired,
  hideHistory: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

ManipButtons.contextTypes = {
  intervention: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default ManipButtons;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/ManipButtons.js